import { withLangPrefix } from '../i18n/locale';
import type { Language } from '../i18n/types';

export const wikiItemHref = (language: Language, wikiPath: string | null | undefined): string | null =>
  wikiPath ? withLangPrefix(language, wikiPath) : null;
